const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year',
        "label": '연도',
        "value": 'year',
        "query": {'y': 'year'},
        "options": {
          default: '',
          useAll: true,
        }
      },
      {
        'component': 'search-column-keyword',
        "label": '검색조건',
        "value": 'column',
        "query": {'ck_t': 'head', 'ck_k': 'keyword'},
        "options": {hiddenList: ['수료일자']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({key: 'header.year', operator: '=', value: search.year})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      { name: "학교(기관)명", key: "body.학교명"  },
      { name: "교육구분", key: "body.교육구분" },
      { name: "업무분야", key: "body.업무분야" },
      { name: "세부직종", key: "body.세부직종" },
      { name: "성명", key: "body.성명" },
      { name: "이수여부", key: "body.이수여부" },
      { name: "이수방법", key: "body.이수방법" },
      { name: "수료일자", key: "body.수료일자" },
    ];
  },
  getCol: (index, value, func) => {
    console.log(func.getContent(value))
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name; // 학교(기관)명
      case 1: return func.getContent(value).교육구분; // 교육구분
      case 2: return func.getContent(value).업무분야; // 업무분야
      case 3: return func.getContent(value).세부직종; // 세부직종
      case 4: return func.onNameBlur(func.getContent(value).성명); // 성명
      case 5: return func.getContent(value).이수여부; // 이수여부
      case 6: return func.getContent(value).이수방법; // 이수방법
      case 7: return func.getContent(value).수료일자; // 수료일자
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
